// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PutKcsConfigsByIdParam, PutKcsConfigsByIdBody, BaseResponseVoid } from '../../types';

/**
 * update
 *
 * @export
 * @tags kcs配置
 * @link [PUT] /kcsConfigs/{id}
 * @param id
 */
export function putKcsConfigsById(
    data: PutKcsConfigsByIdBody,
    options: ApiOptions<PutKcsConfigsByIdParam, never> & { segments: PutKcsConfigsByIdParam }
): Promise<BaseResponseVoid> {
    return request<PutKcsConfigsByIdBody, PutKcsConfigsByIdParam, never>('/kcsConfigs/{id}', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putKcsConfigsById',
    });
}

export const meta = [{ tags: ['kcs配置'], path: '/kcsConfigs/{id}', method: 'put' }];
